import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Fingerprint01 = function Fingerprint01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6.9182 3.3857C8.4074 2.5052 10.1447 2 12 2c5.5228 0 10 4.4772 10 10q0 .0496-.0005.0993M3.3811 6.9259C2.5035 8.4133 2 10.1479 2 12c0 4.6596 3.187 8.5748 7.5 9.685m11.2076-4.7644c-1.3204 2.3316-3.5502 4.0804-6.2076 4.7644m-.4107-15.3112A5.99 5.99 0 0 0 12 6c-3.3137 0-6 2.6863-6 6 0 .7387.1335 1.4463.3777 2.0999m11.2474-4.1922A5.99 5.99 0 0 1 18 12c0 3.3137-2.6863 6-6 6a5.99 5.99 0 0 1-2.0763-.369M12 10v4"
    })
  }));
};
export default Fingerprint01;